export const loadAdobeDTM = () => {
    // Load Adobe DTM script
    if (!document.getElementById("Adobe-DTM-script")) {
        let scriptElement = document.createElement("script");
        scriptElement.src = ADOBE_DTM_SCRIPT;
        scriptElement.setAttribute("data-ot-ignore", "true");
        scriptElement.setAttribute("id", "Adobe-DTM-script");
        document.head.appendChild(scriptElement);
    }
};
